import { render, staticRenderFns } from "./DownloadBadge.vue?vue&type=template&id=b82ff510"
import script from "./DownloadBadge.vue?vue&type=script&lang=js"
export * from "./DownloadBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports